// extracted by mini-css-extract-plugin
export default {"titleContainer":"ln_C2","phoneContainer":"cL1BK","buttonsContainer":"Bk5bC"};